import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../state/state.types';

const mapState = ({ layout }: StateType) => ({
  displayDemo: layout.hideSearch,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
